import React from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { PageHeader, Toolbar, ResponsiveTable, TableSkeleton, EmptyState, DateCell, CopyId } from "@/admin/ui";
import { Search } from "lucide-react";

export default function AdminAudit() {
  const { t } = useLang();
  const [items, setItems] = React.useState(null);
  const [action, setAction] = React.useState("");
  const load = React.useCallback(() => {
    const params = {};
    if (action) params.action = action;
    api.get("/api/admin/audit-logs", { params }).then((r) => setItems(r.data.items));
  }, [action]);
  React.useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6" data-testid="admin-audit-page">
      <PageHeader title={t("admin.audit.title")} description={t("admin.audit.subtitle")} />
      <Toolbar>
        <div className="flex-1 relative min-w-[220px]">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
          <input value={action} onChange={(e) => setAction(e.target.value)}
            placeholder={t("admin.audit.filter_action")}
            className="lp-input w-full pl-9 py-2 text-sm" data-testid="audit-filter-action" />
        </div>
      </Toolbar>
      {!items ? <TableSkeleton rows={8} cols={5} /> : items.length === 0 ? (
        <EmptyState title="No audit entries match your filter" />
      ) : (
        <ResponsiveTable minWidth={900}>
          <thead className="lp-table-sticky"><tr>
            <th>{t("admin.audit.col.at")}</th>
            <th>{t("admin.audit.col.actor")}</th>
            <th>{t("admin.audit.col.action")}</th>
            <th>{t("admin.audit.col.target")}</th>
            <th>{t("admin.audit.col.reason")}</th>
          </tr></thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id}>
                <td><DateCell value={r.created_at} /></td>
                <td className="text-white/85 text-xs">{r.actor_email || r.actor_id || "system"}</td>
                <td className="font-mono text-amber-200 text-xs">{r.action}</td>
                <td><CopyId id={r.target_id || r.target} label="Target" chars={16} /></td>
                <td className="text-white/60 text-xs max-w-[320px] truncate" title={r.reason}>{r.reason || "—"}</td>
              </tr>
            ))}
          </tbody>
        </ResponsiveTable>
      )}
    </div>
  );
}
